import { render, staticRenderFns } from "./arvioinnin-kategoriat.vue?vue&type=template&id=e0be0744&scoped=true&"
import script from "./arvioinnin-kategoriat.vue?vue&type=script&lang=ts&"
export * from "./arvioinnin-kategoriat.vue?vue&type=script&lang=ts&"
import style0 from "./arvioinnin-kategoriat.vue?vue&type=style&index=0&id=e0be0744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0be0744",
  null
  
)

export default component.exports